import reduceReducers from "reduce-reducers";
import { initialState as workSpaceDetailsInitialState, reducer as workSpaceDetailsReducer } from "../workSpaceDetails";
import { initialState as workSpaceEditorPanelInitialState, reducer as workSpaceEditorPanelReducer } from "../workSpaceEditorPanel";
export const initialState = {
    ...workSpaceEditorPanelInitialState,
    ...workSpaceDetailsInitialState
};
export default reduceReducers(initialState, workSpaceEditorPanelReducer, workSpaceDetailsReducer);
